const prefix = "appState";

export const CLIENT_ID_SUCCESS = `${prefix}/CLIENT_ID_SUCCESS`;
export const CLIENTNAME = `${prefix}/CLIENTNAME`;

// need check if this types are necessary
export const USER_LOGGED_OUT = `${prefix}/USER_LOGGED_OUT`;
export const FORGOT_PASSWORD_ERROR = `${prefix}/FORGOT_PASSWORD_ERROR`;
export const FORGOT_PASSWORD_SUCCESS = `${prefix}/FORGOT_PASSWORD_SUCCESS`;
export const SEND_OTP_SUCCESS = `${prefix}/SEND_OTP_SUCCESS`;
export const SEND_OTP_ERROR = `${prefix}/SEND_OTP_ERROR`;
export const CONFIRM_OTP_ERROR = `${prefix}/CONFIRM_OTP_ERROR`;
export const CONFIRM_OTP_SUCCESS = `${prefix}/CONFIRM_OTP_SUCCESS`;
export const ADD_QUESTION = `${prefix}/ADD_QUESTION`;
export const SELECTED_QUESTION = `${prefix}/SELECTED_QUESTION`;
export const ADD_STUDY = `${prefix}/ADD_STUDY`;
export const SURVEY_DETAILS = `${prefix}/SURVEY_DETAILS`;
export const SELECTED_FEATURES = `${prefix}/SELECTED_FEATURES`;
export const ADD_CONSENT_SECTION = `${prefix}/ADD_CONSENT_SECTION`;
export const ADD_OPTIONAL_CONSENT_SECTION = `${prefix}/ADD_OPTIONAL_CONSENT_SECTION`;
export const ADD_CONSENT_QUIZ = `${prefix}/ADD_CONSENT_QUIZ`;
export const ADD_OPTIONAL_CONSENT_QUIZ = `${prefix}/ADD_OPTIONAL_CONSENT_QUIZ`;

export const UPDATE_PROFILE = `${prefix}/UPDATE_PROFILE`;
export const ADD_SCHEDULE = `${prefix}/ADD_SCHEDULE`;
export const SURVEY_QUESTIONS = `${prefix}/SURVEY_QUESTIONS`;
export const SIGNATURE_STATUS = `${prefix}/SIGNATURE_STATUS`;
export const SAVE_SIGNATURE = `${prefix}/SAVE_SIGNATURE`;
export const CANCLE_COHORT_EDITING = `${prefix}/CANCLE_COHORT_EDITING`;
export const TELEHEALTH_VISIT = `${prefix}/TELEHEALTH_VISIT`;
export const VIDEO_CALL_STATUS = `${prefix}/VIDEO_CALL_STATUS`;
export const STATIC_URL = `${prefix}/STATIC_URL`;
export const IS_PUBLISH_DISABLED = `${prefix}/IS_PUBLISH_DISABLED`;
export const IS_PREVIEW_DISABLED = `${prefix}/IS_PREVIEW_DISABLED`;
export const IS_RWEB_PREVIEW_DISABLED = `${prefix}/IS_RWEB_PREVIEW_DISABLED`;
export const TELEHEALTH_APPOINTMENT_DURATION = `${prefix}/TELEHEALTH_APPOINTMENT_DURATION`;
export const SET_PUBLISH_TAB = `${prefix}/SET_PUBLISH_TAB`;

export const ACTIVITY_ROWS = `${prefix}/ACTIVITY_ROWS`;
export const ACTIVITY_DETAILS = `${prefix}/ACTIVITY_DETAILS`;
export const ACTIVITY_QUESTIONS = `${prefix}/ACTIVITY_QUESTIONS`;
export const ADD_ACTIVITY_QUESTION = `${prefix}/ADD_ACTIVITY_QUESTION`;
export const SELECTED_ACTIVITY_QUESTION = `${prefix}/SELECTED_ACTIVITY_QUESTION`;
export const SET_LAST_MODIFIED_ACTIVITY_QUESTION = `${prefix}/SET_LAST_MODIFIED_ACTIVITY_QUESTION`;
export const SAVE_BASE_64_SIGNATURE = `${prefix}/SAVE_BASE_64_SIGNATURE`;
export const SAVE_BASE_64_INITIAL = `${prefix}/SAVE_BASE_64_INITIAL`;

/** Participants Portal - START */
export const PARTICIPANTS_PORTAL_GLOBAL_ELEMENTS = `${prefix}/PARTICIPANTS_PORTAL_GLOBAL_ELEMENTS`;
export const PARTICIPANTS_PORTAL_CONFIG = `${prefix}/PARTICIPANTS_PORTAL_CONFIG`;
export const PARTICIPANTS_PORTAL_LANGUAGES = `${prefix}/PARTICIPANTS_PORTAL_LANGUAGES`;
export const PARTICIPANTS_PORTAL_LANGUAGE_TRANSLATION = `${prefix}/PARTICIPANTS_PORTAL_LANGUAGE_TRANSLATION`;
export const PARTICIPANTS_PORTAL_STRINGS = `${prefix}/PARTICIPANTS_PORTAL_STRINGS`;
export const PARTICIPANTS_PORTAL_BITRISE_DATA = `${prefix}/PARTICIPANTS_PORTAL_BITRISE_DATA`;
export const PARTICIPANTS_PORTAL_STUDY_DATA = `${prefix}/PARTICIPANTS_PORTAL_STUDY_DATA`;
export const PARTICIPANTS_SELECTED_ACTIVITY = `${prefix}/PARTICIPANTS_SELECTED_ACTIVITY`;
export const PARTICIPANTS_ADHERENCES = `${prefix}/PARTICIPANTS_ADHERENCES`;
export const PARTICIPANTS_TASK_SCHEDULES = `${prefix}/PARTICIPANTS_TASK_SCHEDULES`;
export const PARTICIPANTS_STUDY_TASK_SCHEDULES = `${prefix}/PARTICIPANTS_STUDY_TASK_SCHEDULES`;
export const PARTICIPANTS_COUNTRIES = `${prefix}/PARTICIPANTS_COUNTRIES`;
export const PARTICIPANTS_LANGUAGES = `${prefix}/PARTICIPANTS_LANGUAGES`;
export const PARTICIPANTS_STUDY_VIDEOS = `${prefix}/PARTICIPANTS_STUDY_VIDEOS`;
export const PARTICIPANTS_PORTAL_CONSENT_DATA = `${prefix}/PARTICIPANTS_PORTAL_CONSENT_DATA`;
export const PARTICIPANTS_PORTAL_DETAILS = `${prefix}/PARTICIPANTS_PORTAL_DETAILS`;
export const PARTICIPANTS_TELEHEALTH_VIDOCALL_DETAILS = `${prefix}/PARTICIPANTS_TELEHEALTH_VIDOCALL_DETAILS`;
export const PARTICIPANTS_APPOINTMENT_STATUS = `${prefix}/PARTICIPANTS_APPOINTMENT_STATUS`;
export const PARTICIPANTS_ACTIVITY_TRANSLATION = `${prefix}/PARTICIPANTS_ACTIVITY_TRANSLATION`;
export const SELECTED_ACTIVITY = `${prefix}/SELECTED_ACTIVITY`;

/** Participants Portal - END */
export const AWS_COGNITO_AUTHENTICATION = `${prefix}/AWS_COGNITO_AUTHENTICATION`;
export const PWEB_COGNITO_AUTHENTICATION = `${prefix}/PWEB_COGNITO_AUTHENTICATION`;
export const CSSR_ACTIVTY_LANGUAGE = `${prefix}/CSSR_ACTIVTY_LANGUAGE`;
export const SSO_LOGIN_URL = `${prefix}/SSO_LOGIN_URL`;
export const SSO_POOL_CLIENT = `${prefix}/SSO_POOL_CLIENT`;
/** Dynamic Activity Scheduling - Start */
export const STORE_CONSTANT_DYNAMIC_ACTIVITY_SCHEDULES = `${prefix}/STORE_CONSTANT_DYNAMIC_ACTIVITY_SCHEDULES`;
export const STORE_DYNAMIC_ACTIVITY_SCHEDULES = `${prefix}/STORE_DYNAMIC_ACTIVITY_SCHEDULES`;
export const EDIT_SELECTED_DYNAMIC_ACTIVITY_SCHEDULE = `${prefix}/EDIT_SELECTED_DYNAMIC_ACTIVITY_SCHEDULE`;
export const DYNAMIC_SCHEDULE_CONFIGURED_TRIGGERS_DATA = `${prefix}/DYNAMIC_SCHEDULE_CONFIGURED_TRIGGERS_DATA`;
export const DYNAMIC_SCHEDULE_CONFIGURED_ACTIONS_DATA = `${prefix}/DYNAMIC_SCHEDULE_CONFIGURED_ACTIONS_DATA`;
export const DYNAMIC_SCHEDULING_SERVICE = `${prefix}/DYNAMIC_SCHEDULING_SERVICE`;
/** Dynamic Activity Scheduling - End */
export const DATE_RANGE_VIEW_ENABLED = `${prefix}/DATE_RANGE_VIEW_ENABLED`;
export const STUDY_TOGGLED_FEATURES = `STUDY_TOGGLED_FEATURES`;
export const MULTI_FACTOR_AUTH_ENABLED = `MULTI_FACTOR_AUTH_ENABLED`;
export const SITE_DETAILS_DATA = `SITE_DETAILS_DATA`;
export const WEB_SOCKET_SERVICE_DATA = `WEB_SOCKET_SERVICE_DATA`;
